import React from 'react'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'
import MainLayout from '../ui/layout/mainLayout'
import useIsMobile from '../../hooks/useIsMobile'
import withUser from '../../hoc/withUser'

const validateDisabledRoute = disable => disable
const validateLoggedUser = auth => !Object.keys(auth).length
const validateUserPermissions = (auth, permit) =>
  permit && !auth.permisos.some(permiso => permiso.clave === permit)
const validateAllowedParams = (validParams, params) =>
  validParams && !validParams.includes(params)

const PrivateRoute = ({
  auth,
  component: Component,
  permit,
  validParams,
  param,
  disable,
  mobileOnly = false,
  ...rest
}) => {
  const isMobile = useIsMobile()
  const match = useRouteMatch(rest.path)
  const actualParam = param && match ? match.params[param] : undefined

  const invalidRoute =
    validateDisabledRoute(disable) ||
    validateLoggedUser(auth) ||
    validateUserPermissions(auth, permit) ||
    validateAllowedParams(validParams, actualParam)
    
  if (invalidRoute) {
    return <Redirect to="/" />
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (mobileOnly && !isMobile) {
          return <Redirect to="/inicio" />
        }

        return (
          <MainLayout>
            <Component {...props} />
          </MainLayout>
        )
      }}
    />
  )
}

export default withUser(PrivateRoute)
